import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AvaliacoesGestorEdit } from '../../../pages';
import AvaliacoesProvider from '../../../contexts/AvaliacoesContext';

const AvaliacaoGestorRoutes = () => {
  return (
    <AvaliacoesProvider>
      <Routes>
        <Route path={`:id`} element={<AvaliacoesGestorEdit />} />
        <Route path="" element={<AvaliacoesGestorEdit />} />
      </Routes>
    </AvaliacoesProvider>
  );
};

export default AvaliacaoGestorRoutes;
